module.exports = __webpack_public_path__ + "img/brain-arrow-curved-right.bddebafd.svg";